import { render, staticRenderFns } from "./BreadCumb.vue?vue&type=template&id=27ceaff0&"
import script from "./BreadCumb.vue?vue&type=script&lang=js&"
export * from "./BreadCumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports